// RSVP 섹션의 텍스트 에디터 기능을 위한 함수
function rsvp_editor() {
    // 필요한 HTML 요소 선택
    const quillEditorElement = document.getElementById("rsvp_quill_editor");
    const rsvpTitleInput = document.getElementById('rsvp_title_input');
    const rsvpTitle = document.getElementById("rsvp_title");
    const rsvpBody = document.getElementById("rsvp_body");
    
    // 팝업 요소 선택
    const popupRsvpTitle = document.getElementById("popup_rsvp_title");
    const popupRsvpBody = document.getElementById("popup_rsvp_body");

    // 필수 요소가 없을 경우 함수 종료
    if (!quillEditorElement || !rsvpTitleInput || !rsvpTitle || !rsvpBody) {
        return;
    }

    // Quill 에디터 초기화
    const quill = new Quill(quillEditorElement, {
        theme: 'snow',
        modules: {
            toolbar: {
                container: [
                    ['bold', 'italic', 'underline', 'strike', 'link'],  // 텍스트 포맷 및 링크 삽입
                    [{ 'color': [] }, { 'background': [] }] // 텍스트 정렬 및 색상 선택
                ],
                handlers: {
                    link: function () {
                        const value = prompt('연결하실 링크 주소(URL)를 입력해주세요(ex.www.naver.com)');
                        if (value) {
                            const normalizedLink = value.startsWith('http://') || value.startsWith('https://')
                                ? value
                                : `https://${value}`;
                            this.quill.format('link', normalizedLink);
                        }
                    }
                }
            }
        },
        placeholder: '본문 내용을 입력하세요',
    });

    // 초기 Quill 에디터 내용 설정
    const initialContent = rsvpBody.innerHTML.trim();
    quill.clipboard.dangerouslyPasteHTML(initialContent);

    // 초기 타이틀 설정 - rsvp_title 요소의 텍스트를 가져와 설정
    rsvpTitleInput.value = rsvpTitle.innerText.trim();

    // 텍스트 변경 이벤트 리스너 (타이틀)
    rsvpTitleInput.addEventListener('input', function() {
        const newTitle = this.value;
        rsvpTitle.innerText = newTitle;
        
        // 팝업 타이틀도 업데이트
        if (popupRsvpTitle) {
            popupRsvpTitle.innerText = newTitle;
        }
    });

    // 텍스트 변경 이벤트 리스너 (본문)
    quill.on('text-change', function() {
        const html = quill.root.innerHTML;
        rsvpBody.innerHTML = html;
        
        // 팝업 본문도 업데이트
        if (popupRsvpBody) {
            popupRsvpBody.innerHTML = html;
        }
    });

    return quill;
}

export default rsvp_editor; 